import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import moment from 'moment'
import { connect } from 'react-redux'
import { FormControl } from 'react-bootstrap'

import { mapToSelectArray } from 'Shared/helpers'
import { getCategoriesOptions, getSeasonsOptions } from '../../../../selectors'
import { GlgTooltip, GlgPopupForm, GlgFormInput, GlgSelect } from 'SharedComponents'

const ReviewAndCreate = ({
  customerId,
  categoriesOptions,
  seasonsOptions,
  details,
  setDetails,
  dayRoundNumber,
  setStep,
}) => {
  let openedItems = {}
  const [editItem, setEditItem] = useState(openedItems)
  const [rounds, setRounds] = useState([])

  useEffect(() => {
    if (details.rounds.length > 0)
      setRounds(details.rounds)
  }, [details.rounds])

  const uniqueRounds = rounds && [...new Set(rounds.map(item => moment(item).format('ddd MMM DD YYYY')))]
  const reviewItems = [
    {
      label: !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.sim_golf.type_label'),
      value: details.product.charAt(0).toUpperCase() + details.product.slice(1),
      name: 'league[product]',
      identifier: 'product',
    },
    {
      label: !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.sim_golf.name_label'),
      value: details.name,
      name: 'league[name]',
      identifier: 'name',
    },
    {
      label: !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.sim_golf.category_label'),
      value: details.categoryName,
      name: 'category',
      identifier: 'category',
    },
    {
      label: !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.sim_golf.season_label'),
      value: details.seasonName,
      name: 'season',
      identifier: 'season',
    },
    {
      label: !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.sim_golf.dates_label'),
      value: uniqueRounds.map(day => {
        return (
          <span className='review_dates_display'>
            { moment(day.toLocaleString()).format('MMM DD') }
            { dayRoundNumber[day] > 1 && <span className='review_dates_display_info'>{ dayRoundNumber[day] }</span> }
          </span>
        )
      }),
      name: 'dates',
      identifier: 'dates',
    },
  ]

  reviewItems && Object.values(reviewItems).forEach( item => {
    openedItems[item.identifier] = false
  })

  const handleChange = (item, label) => {
    if (item === 'season') {
      const selectedSeason = seasonsOptions.filter(season => season.label === label)
      setDetails({ ...details, seasonName: selectedSeason[0].label, season: selectedSeason[0].value })
    } else if (item === 'category') {
      const selectedCategory = categoriesOptions.filter(category => category.label === label)
      setDetails({ ...details, categoryName: selectedCategory[0].label, category: selectedCategory[0].value })
    } else if (item === 'product') {
      setDetails({ ...details, product: label.toLowerCase()})
    }

    setEditItem({...editItem, [item]: !editItem[item]})
  }

  const handleNameChange = (e) => {
    setDetails({...details, name: e.target.value})
  }

  return (
    <div className='popup_form_content'>
      <h2>{ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.sim_golf.review_and_create_header') }</h2>
      <p className='content_information'>{ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.sim_golf.review_and_create_subtitle') }</p>
      <span className='items_container'>
        <GlgPopupForm>
          <FormControl type='hidden' name='customer_id' value={ customerId } />
          <FormControl type='hidden' name='league_id' value={ details.fromEventLeague } />
          <FormControl type='hidden' name='mass_dates' value={ rounds && rounds.map(day => moment(day).format('MM/DD/YYYY')) }  />
          <FormControl type='hidden' name='product' value={ details.product } />
          <FormControl type='hidden' name='name' value={ details.name } />
          <FormControl type='hidden' name='category' value={ details.category }  />
          <FormControl type='hidden' name='season' value={ details.season } />
          <FormControl type='hidden' name='copy_options' value={ details.copyOptions && details.copyOptions.filter(val => val?.length) }  />
          {reviewItems.map( item =>
            <span className={`review_item ${editItem[item.identifier] ? 'open' : ''} ${item.identifier === 'dates' ? 'review_rounds_item' : ''}`} id='review_item'>
              <GlgFormInput lassName='label' label={ item.label }>
                { editItem[item.identifier] ?
                  item.identifier !== 'name' && item.identifier !== 'dates' ?
                  <GlgSelect
                    className='container_select'
                    name={ item.identifier }
                    items={
                      item.identifier === 'season' ? seasonsOptions :
                      item.identifier === 'category' ? categoriesOptions :
                      [{value: 'event', label: 'Event'}, {value: 'league', label: 'League'}]
                    }
                    value={ details.product }
                    onChange={ (val, label) => handleChange(item.identifier, label) }
                  /> :
                  <FormControl
                    name={ item.name }
                    type='text'
                    defaultValue={ item.value }
                    onChange={ (e) => handleNameChange(e)}
                  /> :
                  <span className={`value ${item.identifier === 'dates' ? 'review_rounds_item_value' : ''}`}>{ item.value }</span>
                }
              </GlgFormInput>
              <span className='edit_icon_container' onClick={ () => item.identifier === 'dates' ? setStep(details.actionType === 'cloneEvent' ? 5 : 4) : setEditItem({...editItem, [item.identifier]: !editItem[item.identifier] }) }>
                <GlgTooltip tooltip={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.sim_golf.edit_tooltip') } placement='top'>
                  <img src={ require('pen.svg') }/>
                </GlgTooltip>
              </span>
            </span>
          )}
        </GlgPopupForm>
      </span>
    </div>
  )
}

ReviewAndCreate.propTypes = {
  details: PropTypes.object.isRequired,
  setDetails: PropTypes.func.isRequired,
  customerId: PropTypes.string.isRequired,
  categoriesOptions: PropTypes.array.isRequired,
  seasonsOptions: PropTypes.array.isRequired,
  dayRoundNumber: PropTypes.object.isRequired,
  setStep: PropTypes.func.isRequired,
}

const mapStateToProps = state => {
  const categoriesOptions = getCategoriesOptions(state, { useManagedCustomer: true })
  const categoriesSelectOptions = mapToSelectArray(categoriesOptions)
  const seasonsOptions = getSeasonsOptions(state, { useManagedCustomer: true })
  const currentSeason = seasonsOptions.find(season => season.isCurrent)
  const currentSeasonId = _.get(currentSeason, 'id')
  const seasonsSelectOptions = mapToSelectArray(seasonsOptions)

  return {
    categoriesOptions: categoriesSelectOptions,
    seasonsOptions: seasonsSelectOptions,
    currentSeasonId,
    customerId: state.misc.managedCustomerId,
  }
}

export default connect(mapStateToProps)(ReviewAndCreate)
